"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationDialog = ConfirmationDialog;
const React = __importStar(require("react"));
const Elements = __importStar(require("../elements"));
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
function ConfirmationDialog(props) {
    const dialog = props.dialog;
    return (React.createElement(Elements.DialogContainer, null,
        React.createElement(Elements.ContainerWithWhiteBorder, null, (() => {
            switch (dialog.type) {
                case "ConfirmationPositiveNegative": {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Elements.DialogHeaderContainer, null,
                            React.createElement("h2", null,
                                React.createElement("span", null, dialog.title)),
                            React.createElement("span", { onClick: dialog.negative.onClick }, "X")),
                        React.createElement(Elements.DialogBodyContainer, null,
                            React.createElement("span", null, dialog.text),
                            React.createElement(Elements.ButtonContainer, null,
                                React.createElement(Elements.StandardButton, { onClick: dialog.positive.onClick },
                                    React.createElement("span", null, dialog.positive.text)),
                                React.createElement(Elements.StandardButton, { onClick: dialog.negative.onClick },
                                    React.createElement("span", null, dialog.negative.text))))));
                }
                case "Confirmation": {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Elements.DialogHeaderContainer, null,
                            React.createElement("h2", null,
                                React.createElement("span", null, dialog.title))),
                        React.createElement(Elements.DialogBodyContainer, null,
                            React.createElement("span", null, dialog.text),
                            React.createElement(Elements.ButtonContainer, null,
                                React.createElement(Elements.StandardButton, { onClick: dialog.positive.onClick },
                                    React.createElement("span", null, dialog.positive.text))))));
                }
                case "ConfirmationPositiveNegativeCancel": {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Elements.DialogHeaderContainer, null,
                            React.createElement("h2", null,
                                React.createElement("span", null, dialog.title)),
                            React.createElement("span", { onClick: dialog.neutral.onClick }, "X")),
                        React.createElement(Elements.DialogBodyContainer, null,
                            React.createElement("span", null, dialog.text),
                            React.createElement(Elements.ButtonContainer, null,
                                React.createElement(Elements.StandardButton, { onClick: dialog.positive.onClick },
                                    React.createElement("span", null, dialog.positive.text)),
                                React.createElement(Elements.StandardButton, { onClick: dialog.negative.onClick },
                                    React.createElement("span", null, dialog.negative.text)),
                                React.createElement(Elements.StandardButton, { onClick: dialog.neutral.onClick },
                                    React.createElement("span", null, dialog.neutral.text))))));
                }
                default: {
                    (0, ts_exhaustive_check_1.exhaustiveCheck)(dialog, true);
                    return null;
                }
            }
        })())));
}
//# sourceMappingURL=confirmation-dialog-component.js.map